export function initFlashHelpers() {
  function hideFlash(event) {
    const { target } = event;
    const btn = target.closest('button[data-action="flash-close"]');
    if (!btn) return;
    const wrapper = target.closest('.flash-info');
    if (!wrapper) return;
    wrapper.remove();
  }

  document.addEventListener('click', hideFlash);
}
